import React from "react";
import { Link } from "react-router-dom";
import "../styles/AboutRImage.css";

function AboutRImage({
  title,
  copy,
  imageSrc,
  secondaryButtonText,
  secondaryButtonLink,
  primaryButtonText,
  primaryButtonLink,
}) {
  return (
	<div className="about-r-image">
	  <div className="about-r-image-content">
		<h2 className="about-r-image-title">{title}</h2>
		<p className="about-r-image-copy">{copy}</p>

		<div className="button-group">
		  {primaryButtonText && primaryButtonLink && (
			<Link to={primaryButtonLink} className="c-ripple primary-button">
			  {primaryButtonText}
			</Link>
		  )}
		  {secondaryButtonText && secondaryButtonLink && (
			<Link to={secondaryButtonLink} className="c-ripple secondary-button">
			  {secondaryButtonText}
			</Link>
		  )}
		</div>
	  </div>

	  <div className="about-r-image-container">
		<div className="about-r-image-wrapper">
		  <img src={imageSrc} alt={title} className="about-r-image-img" />
		  <div className="red-border"></div>
		  <div className="white-border"></div>
		</div>
	  </div>
	</div>
  );
}

export default AboutRImage;